import { ListItemText } from '@material-ui/core';
import { useSwitchUserMutation } from '../../../../services/api/auth';
import { StyledListButton, StyledMobileButton, StyledMobileMenuItem } from '../ui';
import { useDispatch, useSelector } from 'react-redux';

export default function SwitchAccountMenuItem({ isMobile = false }) {
  const dispatch = useDispatch();

  const [switchAccount, { isLoading }] = useSwitchUserMutation();

  const linkedUser = useSelector(state => state.user.user?.linkedUser);
  if (!linkedUser) {
    return null;
  }

  if (isMobile) {
    return (
      <StyledMobileMenuItem>
        <StyledMobileButton type="button" onClick={switchAccount}>
          <ListItemText primary={`Switch to ${linkedUser.linked_user_role}`} />
        </StyledMobileButton>
      </StyledMobileMenuItem>
    );
  }

  return (
    <StyledListButton onClick={switchAccount}>
      <span>{`Switch to ${linkedUser.linked_user_role}`}</span>
    </StyledListButton>
  );
}
